// src/entities/payment/api/stripeQueries.ts
import { useQuery } from '@tanstack/react-query';
import { fetcher } from '@/shared/api';
import { paymentKeys } from './queryKeys';
import type { StripeOnboardingStatus } from '../model/stripeTypes';

interface UseStripeStatusOptions {
  paymentId: string;
  enabled?: boolean;
  /** Set true to poll every 3 s until chargesEnabled becomes true */
  polling?: boolean;
}

export function useStripeOnboardingStatus({
  paymentId,
  enabled = true,
  polling = false,
}: UseStripeStatusOptions) {
  return useQuery<StripeOnboardingStatus>({
    queryKey: paymentKeys.stripeStatus(paymentId),
    queryFn: async () => {
      const res = await fetcher<{ data: StripeOnboardingStatus }>(
        `/payments/${paymentId}/status`,
      );
      return res.data;
    },
    enabled: enabled && !!paymentId,
    staleTime: 0,
    // Poll every 3 s; stop as soon as chargesEnabled is true
    refetchInterval: polling
      ? (data) => (data?.chargesEnabled ? false : 3000)
      : false,
  });
}
